import type { ControlProps } from './types';

export function BooleanControl({ schema, value, disabled, onChange }: ControlProps) {
  return (
    <span className="cf-switch">
      <input
        type="checkbox"
        id={`cf-opt-${schema.id}`}
        aria-label={schema.label}
        checked={value === true}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="cf-slider" />
    </span>
  );
}
